import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmModal = ({
  show,
  title = "Konfirmasi",
  message,
  onConfirm,
  onCancel,
  confirmLabel = "Ya, Hapus",
  confirmVariant = "danger",
}) => (
  <Modal show={show} onHide={onCancel} centered size="sm">
    <Modal.Header closeButton>
      <Modal.Title style={{ fontSize: "1rem" }}>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{message}</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" size="sm" onClick={onCancel}>
        Batal
      </Button>
      <Button variant={confirmVariant} size="sm" onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmModal;
